<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper flexbox-center">
                <div v-if="type !== 'handler'" :class="returnClass()" class="modal-container">
                    <button type="button" class="modal-button-close" @click="closeModal">
                        <span aria-hidden="true" tabindex="-1">×</span>
                    </button>
                    <div class="modal-body">
                        <slot name="body">
                            <component :is="modalType" @resendData="resendData" @changeModal="changeModal" @close="closeModal" :data="modalData" />
                        </slot>
                    </div>
                </div>
                <div v-else class="modal-container">
                    <div class="spinner-container spinner-container-modal">
                        <svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                        </svg>
                    </div>
                    <h4 class="text-center">{{ modalData }}</h4>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import closeModalEnquiry from './../../pages/enquiry/enquiry-modal-close.vue'
import closeModalTask from './../../pages/task/task-modal-close.vue'
import deleteModalEnquiry from './../../pages/enquiry/enquiry-modal-delete.vue'
import dashboardModalFilterSave from './../../pages/dashboard/dashboard-modal-filter-save.vue'
import dashboardModalFilterList from './../../pages/dashboard/dashboard-modal-filter-list.vue'
import taskModalActivity from './../../pages/task/task-modal-activity.vue'
import taskModalActivityTemplate from './../../pages/task/task-modal-activity-template'
import taskModalRoutine from './../../pages/task/task-modal-routine.vue'
import taskModalRequisition from './../../pages/task/task-modal-requisition.vue'
import templateModalActivity from './../../pages/taskTemplate/template-modal-activity.vue'
import requisitionModalActivity from './../../pages/requisition/requisition-modal-activity.vue'
import historyModalDeleteComment from './../../shared/history/history-modal-delete-comment.vue'
import loginModalForgotPassword from './../../pages/login/login-modal-forgotpassword.vue'
import loginModalLoggedout from './../../pages/login/login-modal-loggedout.vue'
import documentModalDescription from './../fileupload/document-modal-description.vue'
import mapModal from './../../shared/map/map-modal'
import propertiesModal from './../../shared/map/properties-modal'
import documentModalReadOnlyDescription from './../fileupload/document-modal-read-only-description.vue'
import plainInformationModal from './../../shared/map/plain-information-modal.vue'
import selectionFilterModal from './../../shared/map/selection-filter-modal.vue'
import requisitionModalLayers from './../../pages/requisition/requisition-modal-layers.vue'
import objectsSelectionFilter from './../../shared/map/objects-selection-filter.vue'

export default {
    name: 'modal',
    props: [
        'type',
        'data'
    ],
    data () {
        return {
            modalType: this.type,
            modalData: this.data,
            smallModal: false
        }
    },
    components: {
        'dashboard-modal-filter-save': dashboardModalFilterSave,
        'dashboard-modal-filter-list': dashboardModalFilterList,
        'task-modal-activity': taskModalActivity,
        'task-modal-activity-template': taskModalActivityTemplate,
        'task-modal-routine': taskModalRoutine,
        'task-modal-requisition': taskModalRequisition,
        'task-modal-close': closeModalTask,
        'template-modal-activity': templateModalActivity,
        'requisition-modal-activity': requisitionModalActivity,
        'enquiry-modal-close': closeModalEnquiry,
        'enquiry-modal-delete': deleteModalEnquiry,
        'history-modal-delete-comment': historyModalDeleteComment,
        'login-modal-forgotpassword': loginModalForgotPassword,
        'login-modal-loggedout': loginModalLoggedout,
        'document-modal-description': documentModalDescription,
        'map-modal': mapModal,
        'properties-modal': propertiesModal,
        'document-modal-read-only-description': documentModalReadOnlyDescription,
        'plain-information-modal': plainInformationModal,
        'selection-filter-modal': selectionFilterModal,
        'requisition-modal-layers': requisitionModalLayers,
        'objects-selection-filter': objectsSelectionFilter
    },
    methods: {
        resendData (data) {
            this.$emit('resendData', data)
        },
        changeModal (data) {
            this.modalType = data.modalType
            this.modalData = data.modalData
        },
        closeModal () {
            this.$emit('close')
        },
        returnClass () {
            if (this.smallModal) {
                return 'small-modal-container'
            } else if (this.type === 'dashboard-modal-filter-save') {
                return 'dashboard-modal-container'
            }
        }
    },
    watch: {
        modalType (value) {
            this.modalType = value
        },
        modalData (value) {
            this.modalData = value
        }
    },
    created () {
        this.modalType = this.type
        if (this.type === 'plain-information-modal') {
            setTimeout(function () {
                console.log('emit close')
            }, 3000)
        }
        if (this.type === 'login-modal-forgotpassword') {
            this.smallModal = true
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/modal/modal.vue